import { Model } from 'pinia-orm';
import User from './User';
import CompanyUser from './CompanyUser';
import Subscription from './Subscription';
import Job from './Job';
import Jobsite from './Jobsite';
import Company from "./Company";


export default class Invoice extends Model {

    static get entity () {
        return 'invoices'
    }

    static fields () {
        return {
            id: this.uid(),
            company_id: this.attr(null),
            user_id: this.attr(null),
            title: this.attr(null),
            subtotal: this.attr(null),
            tax: this.attr(null),
            total: this.attr(null),
            state: this.attr(null),
            type: this.attr(null),
            pdf: this.attr(null),
            is_expired: this.attr(false),
            is_creditnote: this.attr(false),
            metadata: this.attr(null),
            created_at: this.attr(null),
            due_date: this.attr(null),
            updated_at: this.attr(null),
            paid_at: this.attr(null),

            //relations
            company: this.belongsTo(Company, 'company_id'),
            user: this.belongsTo(User, 'user_id')
        }
    }
}
